import './ResultsSelectedTag.scss'
import {SearchItem} from '../../../model/SearchItem'
import React from 'react'
import { Button, ButtonGroup } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'

export interface ResultsSelectedBadgeProps {
    resultsList: SearchItem[],
    resetResults: () => void
}

const ResultsSelectedTag = (props: ResultsSelectedBadgeProps) => {

    const { resultsList, resetResults } = props

    return (
        <ButtonGroup data-testid={'results-selected-tag'} className={`results-button-group ${resultsList.length === 0 ? 'hidden' : ''}`}>
            <Button data-testid={'results-selected-tag-clear'} className={'results-button'} onClick={resetResults}>
                <ClearIcon className={'clear-icon'} />
            </Button>
            <Button data-testid={'results-selected-tag-info'} className={'results-info'} disabled>
                {`${resultsList.length} Selected`}
            </Button>
        </ButtonGroup>
    )
}

export default ResultsSelectedTag
